import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import MobileNav from "./MobileNav";
import DesktopNav from "./DesktopNav";
import logo from "../images/Nkenne Ai-01 2.png";

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="flex items-center justify-between px-6 py-6 relative z-[99]">
      {/* Logo */}
      <div className="flex items-center">
        <Link to="/">
          <img src={logo} alt="NKENNE Ai Logo" className="h-10" />
        </Link>
      </div>

      {/* Desktop Navigation */}
      <DesktopNav location={location} />

      {/* Mobile Menu Button */}
      <button className="block md:hidden focus:outline-none" onClick={toggleMenu}>
        <FiMenu size={28} />
      </button>

      {/* Mobile Navigation */}
      {isOpen && <MobileNav location={location} toggleMenu={toggleMenu} />}
    </nav>
  );
};

export default Navbar;
